const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'added';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[data-button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product_card',
};
const CId = ShopifyAnalytics.meta.page.customerId;

$(document).ready(function () {
  activeWishlistTab()
});

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
  wishlistAnimation()
});

function activeWishlistTab() {
  if (window.location.pathname == "/account") {
    const urlParams = new URL(`${window.location.href}`).searchParams;
    if (urlParams.get("wishlist")) {
      setTimeout(function () {
        const wishlistTab = document.querySelector("#whislist-tab");
        const clickEvent = new Event("click", {
          bubbles: true,
          cancelable: true,
        });
        wishlistTab.dispatchEvent(clickEvent);
      }, 10);
      $(".tab-content #wishlist .tab-accordion-position").addClass("opened");
      $(".tab-content #wishlist .tab-accordion-position-content").show();
    }
  }
}

function wishlistAnimation() {
  let wishlistItemLength = getWishlist().length;
  if (wishlistItemLength > 0) {
    $(".wishlistAnimation").removeClass("d-none");
    $(".wishlistAnimation").addClass("Animation");
    setTimeout(function () {
      $(".wishlistAnimation").removeClass("Animation");
    }, 1000);
    $("[data-wishlist-count]").text(wishlistItemLength).show();
  } else {
    $(".wishlistAnimation").addClass("d-none");
    $("[data-wishlist-count]").hide();
  }
}

document.addEventListener('shopify-wishlist:updated', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    })
    .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  if (wishlist.length !== 0) {
    const requests = wishlist.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);
    const wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();
    const event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  } else {
    $("#wishlistProList").empty();
    $("#wishlist .wishlistText").hide();
    insertEmptyData();
  }
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
      $(button).attr("title", "Remove from the wishlist");
    } else {
      $(button).attr("title", "Add to wishlist");
    }
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      if (button.classList.contains(BUTTON_ACTIVE_CLASS)) {
        button.classList.remove(BUTTON_ACTIVE_CLASS);
        $(button).attr("title", "Add to wishlist");
      } else {
        button.classList.add(BUTTON_ACTIVE_CLASS);
        $(button).attr("title", "Remove from the wishlist");
      }
      if (CId !== undefined && CId !== "") {
        wishlistAnimation()
      } else {
        let searchParams = new URLSearchParams(window.location.search);
        let hrefUrl = window.location.host; // e.g., www.cerascreen.fr
        let pathname = window.location.pathname; // e.g., "/products/test-ige-aux-allergies-complet"
        let countryCode = hrefUrl.includes('.co.uk') ? 'co.uk' : hrefUrl.split('.').pop();
        let url = `https://my.cerascreen.${countryCode}/users/sign_in?store_url=https://www.cerascreen.${countryCode}${pathname}`;
        window.open(url, "_self");
      }
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

// Empty Data Add
function insertEmptyData() {
  let dataHtml = `<div class="text-center empty_wishlist_data">
      <div class="courses_img mt-5 mb-7">
        <img src="https://cdn.shopify.com/s/files/1/1705/8705/files/empty_whishlist_ico.svg" alt="Empty Wishlist" loading="lazy" width="150" height="161" />
      </div>
      <h3 class="mb-2">You haven&#39;t added any favorites yet</h3>
      <p class="m-auto mb-6 col-md-10 col-lg-8 col-xl-6">Remember your favorites: By adding products to your favorites list, you can quickly find them again in this overview later. Simply click on the heart symbol next to a product on one of our category pages.</p>
      <a aria-label="Empty Wishlist" class="btn btn-primary" href="/collections/selftests" >Go to the &#39;Tests&#39; category</a>
    </div>`;
  $('#wishlistProList').append(dataHtml);
}